import React from 'react';
// import NewsletterSubscribe from './NewsLetter';
import FooterMain from './Main';
import Branch from '../../../models/branch.model';
interface Props{
  branch?:Branch|undefined
}

const Footer:React.FC<Props> = ({branch})=>{
  return(
    <footer className="ecn-footer">
     {/* <NewsletterSubscribe/> */}
     <FooterMain branch={branch}/>
    </footer>
  );
}

export default Footer;